import { render, staticRenderFns } from "./FinancialReport.vue?vue&type=template&id=604c7074&scoped=true&"
import script from "./FinancialReport.vue?vue&type=script&lang=js&"
export * from "./FinancialReport.vue?vue&type=script&lang=js&"
import style0 from "./FinancialReport.vue?vue&type=style&index=0&id=604c7074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c7074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VIcon,VList,VListGroup,VTabItem,VTabsItems})
